export class RecordNotFoundException extends Error {
  constructor(id: number | string, isIndex = false) {
    super(RecordNotFoundException.createMessage(id, isIndex));
  }

  private static createMessage(id: number | string, isIndex: boolean): string {
    if (isIndex) {
      return `Record with Index '${id}' not found.`;
    }
    return `Record with Id '${id}' not found.`;
  }
}
